import React, { useState, useEffect } from "react";
import "./Shoulde.css";
import { FaRegWindowClose } from "react-icons/fa";

const AddRemove = ({ files, setFiles }) => {
  const [inputList, setInputList] = useState([{}]);
  // setFiles(inputList);

  useEffect(() => {
    files !== null && setInputList(files);
  }, []);

  console.log("inputList", files);
  const handleInputChange = (e, index) => {
    const { files } = e.target;
    let list;
    if (inputList.length === 1) {
      list = [files[0]];
    } else {
      const alreadyFiles = inputList.filter((file) => {
        if (file.name) {
          return file;
        }
      });
      list = [...alreadyFiles, files[0]];
    }
    setInputList(list);
    setFiles(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
    setFiles(list);
  };
  const handleAddClick = () => {
    setInputList([...inputList, {}]);
    setFiles([...inputList, {}]);
  };

  return (
    <div className="App">
      <div className="btn-box ">
        {
          <button className="addbtnfile" onClick={handleAddClick}>
            + Add More
          </button>
        }
      </div>
      {inputList.map((x, i) => {
        return (
          <div className="box">
            {console.log("x", x)}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <input
                  className="form-control"
                  placeholder="zain amin"
                  style={{
                    marginBottom: "15px",
                    fontSize: "13px",
                    fontFamily: "Poppins",
                    width: "100%",
                  }}
                  type="file"
                  id="formFileMultiple"
                  onChange={(e, i) => handleInputChange(e, i)}
                />
                <div style={{ marginLeft: "10px" }}>
                  {!i == 0 && (
                    <FaRegWindowClose
                      size={32}
                      color="#ff9500"
                      className="closemm"
                      onClick={() => handleRemoveClick(i)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
  // const [values, setValues] = useState({ val: [] });
  // function createInputs() {
  //   return values.val.map((el, i) => (
  //     <div key={i}>
  //       <input
  //         className="form-control"
  //         style={{
  //           marginBottom: "15px",
  //           fontSize: "13px",
  //           fontFamily: "Poppins",
  //           width: "100%",
  //         }}
  //         type="file"
  //         id="formFileMultiple"
  //         // onChange={(e, i) => handleInputChange(e, i)}
  //       />
  //       <input type="button" value="remove" onClick={removeClick.bind(i)} />
  //     </div>
  //   ));
  // }
  // function handleChange(event) {
  //   let vals = [...values.val];
  //   vals[this] = event.target.value;
  //   setValues({ val: vals });
  // }
  // const addClick = () => {
  //   setValues({ val: [...values.val, ""] });
  // };
  // const removeClick = () => {
  //   let vals = [...values.val];
  //   vals.splice(this, 1);
  //   setValues({ val: vals });
  // };
  // const handleSubmit = (event) => {
  //   alert("A name was submitted: " + values.val.join(", "));
  //   event.preventDefault();
  // };
  // return (
  //   <form onSubmit={handleSubmit}>
  //     {createInputs()}
  //     <input type="button" value="add more" onClick={addClick} />
  //     <input type="submit" value="Submit" />
  //   </form>
  // );
};

export default AddRemove;
